module.exports = __webpack_public_path__ + "img/BS.bedfd2d7.png";